import { useState, useEffect } from 'react';
import { Form, Input, message, Button, List, Typography } from 'antd';
import { notifyMessages, requiredMessages } from '../../utils/constants';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useCurrentUserContext } from '../../context/currentUserContext';
import DocumentsServices from '../../services/documentsServices';
import dayjs from 'dayjs';
import { isSuperAdmin } from '../../configs/auth/roleRights';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const { TextArea } = Input;
const { Text } = Typography;

const DocumentNotes = ({ documentId, getDocumentDataByID, setDocNotesToParent }) => {

    const [form] = Form.useForm();
    const { currentUser } = useCurrentUserContext();
    const [documentNotes, setDocumentNotes] = useState([]);
    const [loadingNotes, setLoadingNotes] = useState();

    const [loadingAddNote, setLoadingAddNote] = useState();
    const [loadingNoteRemove, setLoadingNoteRemove] = useState(false);

    useEffect(() => {
        getDocumentNotesList(documentId);
    }, []);


    const getDocumentNotesList = async (documentId) => {
        setLoadingNotes(true);
        try {
            const respData = await DocumentsServices.getDocumentNotes(documentId);
            if (respData.success) {
                let result = respData.responseObject.value.documentNotes;
                setDocumentNotes(result);
                setDocNotesToParent(result);
            } else {
            }
        } catch (error) {
        }
        finally {
            setLoadingNotes(false)
        }
    };


    const handleAddDocumentNote = async (values) => {
        setLoadingAddNote(true);
        values["documentID"] = documentId;
        values["userID"] = currentUser.id;

        try {
            const respData = await DocumentsServices.addDocumentNote(values);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                getDocumentDataByID(documentId, currentUser.id);
                getDocumentNotesList(documentId);
                form.resetFields();
            } else {
                message.error(notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);

        }
        finally {
            setLoadingAddNote(false);
        }
    };

    const onNoteRemove = async (noteId) => {
        setLoadingNoteRemove(true);
        try {
            const respData = await DocumentsServices.removeDocumentNote(noteId);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                getDocumentNotesList(documentId);
            } else {
                message.error(notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        } finally {
            setLoadingNoteRemove(false);
        }
    };


    return (
        <Form form={form} layout="vertical" onFinish={handleAddDocumentNote}>
            <Form.Item
                label={<strong>Note:</strong>}
                name="note"
                rules={[{ required: true, message: requiredMessages.requiredField }]}
            >
                <TextArea rows={4} style={{ width: "100%" }} />
            </Form.Item>
            <div className="notes-list">
                <List
                    dataSource={documentNotes}
                    renderItem={(note) => (
                        <List.Item className="notes-list-item" actions={isSuperAdmin(currentUser) && [<Button loading={loadingNoteRemove} size="small" type="ghost" icon={<DeleteOutlined />} onClick={() => onNoteRemove(note.id)} />]}>
                            <span className="notes-list-circle">○</span>
                            [ {<Text strong>{note.operationDate ? dayjs.utc(note.operationDate).tz(dayjs.tz.guess()).format("ddd D MMM YYYY HH:mm") : ""} | {note?.userName}</Text>} ] - {note.description}
                        </List.Item>
                       
                    )}
                />
            </div>
            <div className="filterButtons">
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loadingAddNote}
                    icon={<PlusOutlined />}
                >
                    Aggiungi
                </Button>
            </div>
        </Form>

    );
}
export default DocumentNotes;